module.exports = __webpack_public_path__ + "static/img/arrow.5b953de.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructions/img/arrow.png
// module id = U4qW
// module chunks = 0